/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCustomersBaseRequest } from '../../models/get-customers-base-request';
import { GetCustomersResponse } from '../../models/get-customers-response';

export interface PostApiCustomerV1$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetCustomersBaseRequest
}

export function postApiCustomerV1$Plain(http: HttpClient, rootUrl: string, params?: PostApiCustomerV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCustomersResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCustomersResponse>;
    })
  );
}

postApiCustomerV1$Plain.PATH = '/private/v1/customers';
